module.exports = __webpack_public_path__ + "img/star1.c6bdb094.png";